module.exports = __webpack_public_path__ + "media/assets/avia/sidebar/alarm-bdcfa178e498bde8fc84e535383f4d37.png";